<template>
  <VHistory business-model="reselling" :route-overview="BARRING_RESELLING_HISTORY" :route-details="BARRING_RESELLING_HISTORY_STATUS">
    <template #header>
      <VButton label="barring.button_backToResellingBarringStatusPage" class="btn-brand offset-bottom-2" :to="{ name: BARRING_RESELLING_STATUS }" />

      <p v-html="$t('barring.history_reselling_details_text')"></p>
    </template>

    <template #details="{ validFrom, validTo, isResellingBarred, resellingItems }">
      <h4 class="h3" v-html="$t('barring.history_details_headline', { validFrom, validTo, profile: $t('barring.statusType_reselling') })" />

      <section role="list" class="offset-top-2 offset-bottom-3">
        <VStatus role="listitem" type="reselling" :is-barred="isResellingBarred" :items="resellingItems" />
      </section>
    </template>
  </VHistory>
</template>

<script>
import VButton from '@/components/Button';
import VHistory from '@/components/Barring/History';
import VStatus from '@/components/Barring/Status';
import { BARRING_RESELLING_STATUS, BARRING_RESELLING_HISTORY, BARRING_RESELLING_HISTORY_STATUS } from '@route-types';

export default {
  name: 'BarringResellingHistory',

  components: {
    VButton,
    VHistory,
    VStatus,
  },

  data() {
    return {
      BARRING_RESELLING_STATUS,
      BARRING_RESELLING_HISTORY,
      BARRING_RESELLING_HISTORY_STATUS,
    };
  },
};
</script>
